import { Store } from "vuex";
import { namespace as subscriptionsNamespace } from "../modules/subscriptions/subscriptions";
import { Subscription, SubscriptionPatch } from "@infoland/iprova-api";

export class SubscriptionsStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the loaded subscriptions */
    public get subscriptions(): Subscription[] {
        return this.store.getters[`${subscriptionsNamespace}/subscriptions`];
    }

    /** Loads the subscriptions */

    public async loadMySubscriptionsAsync(): Promise<Subscription[]> {
        return this.store.dispatch(`${subscriptionsNamespace}/loadMySubscriptionsAsync`);
    }

    /**
     * Saves the user subscription
     * @param subscription_Id id of the subscription to be updated
     * @param subscriptionPatch the data of the subscription that is updated
     */
    public async saveSubscriptionAsync(subscription_Id: number, subscriptionPatch: SubscriptionPatch): Promise<boolean> {
        return this.store.dispatch(`${subscriptionsNamespace}/saveSubscriptionAsync`, { subscription_Id, subscriptionPatch });
    }
}
